"use strict";

module.exports = require("./is-implemented")() ? Object.keys : require("./shim");



//////////////////
// WEBPACK FOOTER
// /~/es5-ext/object/keys/index.js
// module id = 2014
// module chunks = 0